import { useState } from "react";

interface propsReq {
  title: string;
}

export default function BreadCrum(props: propsReq) {
  const [title] = useState(props.title);
  return (
    <>
      <h5 className="p-ml-3" style={{ fontWeight: "bold", marginBottom: "0" }}>
        {title}
      </h5>
    </>
  );
}
